module.exports = __webpack_public_path__ + "static/media/477586bad8b3db7d.3309fb6b.png";